<template>
  <div class="article-area__article group" data-testid="en-story-card">
    <nuxt-link :to="`/stories/${props.enStory.id}/`">
      <!-- wabunka story -->
      <div class="eye-catch duration-500 hover:before:bg-white-transparent-15 hover:before:transition-all">
        <OptimizedImage :alt="`${props.enStory.title}の画像`" :image-url="props.enStory.thumbnailImage.url" :optimized-image-options="{ width: 560 }" />
        <div class="eye-catch__bottom-grad"></div>
      </div>
      <div class="content">
        <div class="content__providerName">
          <p class="text-gray1 duration-500 group-hover:!text-gold2 md:text-white">{{ props.enStory.provider.name }}</p>
        </div>
        <div class="content__title">
          <h3 class="text-white duration-500 group-hover:!text-gold2">{{ props.enStory.title }}</h3>
        </div>
      </div>
    </nuxt-link>
  </div>
</template>

<script lang="ts" setup>
import type { MinimalEnStoryViewModel } from '@/models/wabunka/enStories';
import { OptimizedImage } from '@/wabunka-src/common/components';
interface Props {
  enStory: MinimalEnStoryViewModel;
}

const props = defineProps<Props>();
</script>

<style lang="scss" scoped>
.article-area__article {
  overflow: hidden;
  width: 49%;
  margin-bottom: 24px;
  @media screen and (min-width: 768px) {
    position: relative;
    padding: 20px 0 0 0;
    width: 24%;
    margin-bottom: 0;
  }
  a {
    text-decoration: none;
  }
  &:hover {
    .eye-catch {
      img {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
        transition: 0.5s;
      }
    }
  }
  .eye-catch {
    overflow: hidden;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      display: block;
      z-index: 2;
      transition: all 0.5s;
    }
    &__bottom-grad {
      position: absolute;
      width: 100%;
      height: 125px;
      bottom: 0;
      left: 0;
      background: linear-gradient(to bottom, rgba(51, 51, 51, 0) 0%, rgba(51, 51, 51, 0.5) 100%);
    }
    img {
      transition: 0.5s;
    }
  }

  .content {
    margin: 16px 0 8px;
    @media screen and (min-width: 768px) {
      position: absolute;
      bottom: 0;
      margin: 16px;
    }
    &__ {
      &providerName {
        margin-bottom: 4px;
        p {
          font-size: 12px;
          line-height: 22px;
          letter-spacing: 0.5px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          @media screen and (min-width: 768px) {
            font-size: 12px;
            line-height: 20px;
            letter-spacing: 1px;
          }
        }
      }
      &title {
        h3 {
          font-size: 12px;
          line-height: 22px;
          letter-spacing: 0.5px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          @media screen and (min-width: 768px) {
            font-size: 14px;
            line-height: 24px;
            letter-spacing: 0.04em;
            -webkit-line-clamp: 2;
          }
        }
      }
    }
  }
}
</style>
